import { UserSortField } from "@/graphql/codegen/graphql"

export type UserSortableAccessorKey = "name"

export const accessorKeyToUserSortField = new Map<UserSortableAccessorKey, UserSortField>([
  ["name", UserSortField.Name],
])

export const userSortFieldToAccessoryKey = new Map<UserSortField, UserSortableAccessorKey>([
  [UserSortField.Name, "name"],
])
